export const CHANGE_FILTER = 'CHANGE_FILTER';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';

export const TOGGLE_FILTER_REGION = 'TOGGLE_FILTER_REGION';

// MOBILE
export const SET_FILTERS = 'SET_FILTERS';
export const APPLY_FILTERS = 'APPLY_FILTERS';
export const CANCEL_FILTERS = 'CANCEL_FILTERS';
export const SAVE_FILTERS_FOR_CANCEL = 'SAVE_FILTERS_FOR_CANCEL';

// MobileHotelFilter
export const SET_MOBILE_HOTEL_FILTER_OPENED = 'SET_MOBILE_HOTEL_FILTER_OPENED';
